

// FOR REDUCER
export interface AuthenticationState {
  isLoggedIn: boolean;
  isProfileUpdated: boolean;
  user: User | null;
  error: string | null;
  isAvatarProcessing: boolean;
  loading: boolean;
}

export const sharedInitialState: AuthenticationState = {
  isLoggedIn: false,
  isProfileUpdated: false,
  user: null,
  error: null,
  isAvatarProcessing: false,
  loading: false
}


//OTHERS
export class User {
  id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  club_id?: string;
  token?: string;
  lang?: string;
  avatar?: string;
  company_logo?: string;
  company_name?: string;
  get_new_task_email: boolean;
  qrcode?: string | null;
  has_back_link?: boolean;
  two_factor_backup_codes?: [];
}

export interface TwoFactorQr {
  qrcode?: string;
}

export interface TwoFactorCode {
  code?: string;
}

export interface PasswordSetup {
  password?: string;
}

export interface ForgotEmail {
  email?: string;
}

export interface LoginData {
  email?: string;
  password?: string;
}

export interface resetPasswordData {
  token?: string;
  email?: string;
  password?: string;
}